export const FETCH_IDEAS = 'FETCH_IDEAS';
export const FETCH_IDEA = 'FETCH_IDEA';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT'
export const ADD_IDEA = 'ADD_IDEA';
export const REMOVE_IDEA = 'REMOVE_IDEA';
export const EDIT_IDEA = 'EDIT_IDEA';
export const ADD_RESOURCE = 'ADD_RESOURCE';
export const REMOVE_RESOURCE = 'REMOVE_RESOURCE';
export const EDIT_RESOURCE = 'EDIT_RESOURCE';
export const ADD_FAVORITE_IDEA = 'ADD_FAVORITE_IDEA';
export const REMOVE_FAVORITE_IDEA = 'REMOVE_FAVORITE_IDEA';
export const USER_FAV_CHANGE = 'USER_FAV_CHANGE';
export const LOAD_USER_FAVORITES = 'LOAD_USER_FAVORITES';


// WEBPACK FOOTER //
// ./src/actions/types.js